import React from 'react';
import classNames from 'classnames';

import { Glyphicon } from '@bingads-webui-react/primitive';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { useI18n } from '@bingads-webui-campaign-react/smart-page-context';

import { useCouponDetailContext } from './use-coupon-detail';

const getStyles = () => ({
  couponIcon: {
    'font-size': '16px !important',
    'line-height': '0.5 !important',
    top: '0px !important',
    margin: '8px',
    color: '#0078D4',
  },
  couponText: {
    fontSize: '14px',
    lineHeight: '20px',
  },
  couponMessageContainer: {
    display: 'flex',
    marginRight: '10px',
    marginTop: '25px',
  },
});

export const CouponMessage = () => {
  const classes = useDefaultStyles(getStyles);
  const i18n = useI18n();
  const couponDetail = useCouponDetailContext();

  if (!couponDetail) {
    return null;
  }

  // Coupon expiry date is in PST
  const localExpiredDate = new Date(`${couponDetail.ExpiryDate}-08:00`);

  return (
    <div className={classNames('coupon-message-container', classes.couponMessageContainer)}>
      <Glyphicon
        className={classNames(classes.couponIcon, 'coupon-solid-icon')}
        glyph="ba-CouponSolid"
      />
      <div className={classNames('coupon-text', classes.couponText)}>
        {/* TODO add helper for dynamic coupon text if we have different types */}
        {i18n.getString(
          _TL_('Sign up before {{localDateString}} to receive $100 in advertising credit after spending your first $25.'),
          {
            localDateString: localExpiredDate.toLocaleDateString(),
          }
        )}
      </div>
    </div>
  );
};
